<template>
  <div class="o-community-selection-card">
    <div class="title mb-2">
      {{ $t('components.product.OCommunitySelectionCard.exclusiveProduct') }}
    </div>

    <div class="description">
      {{ $t('components.product.OCommunitySelectionCard.willBeAvailableForOrder') }} {{ dateText }}.
      {{ $t('components.product.OCommunitySelectionCard.saveToYourWishlist') }}. <nuxt-link
        :to="bannerLink"
        @click.prevent="onBannerLinkClick"
      >
        {{ $t('common.learnMore') }}
      </nuxt-link>
    </div>
  </div>
</template>

<script setup lang="ts">
import { genSPALink } from '~/utils/extra';

const { globalSettings } = useAccountStore();
const { getTimeFromNow } = useDateFormatter({
  thresholds: { hh: 50 },
});

const props = defineProps<{
  date: string
  isMale?: boolean
}>();
const emits = defineEmits<{
  (e: 'bannerLinkClicked'): void,
}>();

const dateText = computed(() => getTimeFromNow(new Date(props.date), false));
const bannerLink = computed(() => {
  const tabBarSettings = globalSettings.value.exclusiveSelectionBannerSettings || {};
  const maleLink = tabBarSettings.exclusiveSelectionMaleBannerLink;
  const femaleLink = tabBarSettings.exclusiveSelectionFemaleBannerLink;

  return props.isMale ? maleLink : femaleLink;
});

async function onBannerLinkClick() {
  emits('bannerLinkClicked');

  if (!bannerLink.value) {
    return;
  }

  await navigateTo(genSPALink(bannerLink.value));
}
</script>

<style scoped lang="scss">
@import "~/assets/scss/settings/index";

.o-community-selection-card {
  padding: 16px;
  color: white;
  background: linear-gradient(263.56deg, #818181 0%, #000000 91.7%);
  font-family: $font-family-default;
}

.title {
  font-size: 16px;
  font-weight: 700;
  line-height: 19.5px;
  text-align: left;
}

.description {
  font-size: 12px;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.11px;

  @include media-query(md-and-up) {
    font-size: 14px;
    letter-spacing: 0.1px;
  }

  a {
    font-weight: 600;
    text-decoration: underline;
  }
}
</style>
